import { observable, computed, action } from "mobx";
import { BarSalesData } from "../components/BarElement";
import Axios, { AxiosResponse } from "axios";
import AuthenticationStore from "./AuthenticationStore";
import AppRegistryStore from "./AppRegistryStore";
import SalesDataModel from "../models/SalesDataModel";

export default class SalesDataStore {
    private _appRegistryStore: AppRegistryStore;
    private _authenticationStore: AuthenticationStore;
    @observable private _salesData: SalesDataModel | null = null;
    @observable private _barSalesDataList: Array<BarSalesData> = [];
    @observable private _hasNoData: boolean = false;

    constructor(appRegistryStore: AppRegistryStore, authenticationStore: AuthenticationStore) {
        this._appRegistryStore = appRegistryStore;
        this._authenticationStore = authenticationStore;
    }

    @computed get salesData() {
        return this._salesData;
    }

    @computed get barSalesDataList() {
        return this._barSalesDataList;
    }
    @computed get hasNoData() {
        return this._hasNoData;
    }

    @action fetch(obfuscatedIds?: string) {
        this._salesData = null;
        this._barSalesDataList = [];

        let url;
        if (obfuscatedIds !== undefined && this._authenticationStore.isAdmin()) {
            const ids = JSON.parse(atob(obfuscatedIds!));
            
            // const baseUrl = 'http://localhost:50801';
            // url = baseUrl + "/v2/SalesRep/CustomerNumber/" + ids.customerId + "/BranchNumber/" + ids.branchId;
            url = this._appRegistryStore.mobileApiUrl + "/v2/SalesRep/CustomerNumber/" + ids.customerId + "/BranchNumber/" + ids.branchId;
        } else {
            url = this._appRegistryStore.mobileApiUrl + "/v3/ParticipantSalesData";
        }

        return Axios.get<any, AxiosResponse<any>>(url, { headers: { Authorization: "Bearer " + this._authenticationStore.token } })
            .then((res: AxiosResponse<any>) => {
                // res.data = JSON.parse('{"BranchNumber":31,"CustomerNumber":4500,"YtdSales":15230.0,"YtdPercentGrowth":55.0,"YtdPoints":171111.0,"ProjectedSales":25630.0,"ProjectedPercentGrowth":92.0,"ProjectedPoints":25.0,"SalesGoal":100000.0,"PercentGrowthGoal":30.0,"PointsGoal":150000.0,"ProjectedSalesGoalPercent":25.629999999999995,"ProjectedPointsGoalPercent":0.016666666666666666,"ProjectedPercentGrowthGoalPercent":306.66666666666669,"PopupMessage":null,"LastUpdate":"2020-06-09T05:00:02"}');
                

                if(res.data.BranchNumber === 0 && res.data.CustomerNumber === 0) {
                    this._hasNoData = true;
                } else {
                    this._hasNoData = false;
                }
                //fix for not being able to update in prod;
                // res.data.SalesGoal = 100000;
                this._salesData = {
                    branchNumber: res.data.BranchNumber,
                    customerNumber: res.data.CustomerNumber,
                    ytdSales: res.data.YtdSales,
                    ytdPercentGrowth: res.data.YtdPercentGrowth,
                    ytdPoints: res.data.YtdPoints,
                    projectedSales: res.data.ProjectedSales,
                    projectedPercentGrowth: res.data.ProjectedPercentGrowth,
                    projectedPoints: res.data.ProjectedPoints,
                    salesGoal: res.data.SalesGoal,
                    percentGrowthGoal: res.data.PercentGrowthGoal,
                    pointsGoal: res.data.PointsGoal,
                    projectedSalesGoalPercent: res.data.ProjectedSalesGoalPercent,
                    projectedPointsGoalPercent: res.data.ProjectedPointsGoalPercent,
                    projectedPercentGrowthGoalPercent: res.data.projectedPercentGrowthGoalPercent,
                    popupMessage: res.data.PopupMessage,
                    lastUpdate: res.data.LastUpdate
                }

                this._barSalesDataList = [
                    {
                        ytd: res.data.YtdSales,
                        projected: res.data.ProjectedSales,
                        goal: res.data.SalesGoal,
                        goalPercent: res.data.ProjectedSalesGoalPercent
                    },
                    {
                        ytd: res.data.YtdPoints,
                        projected: res.data.ProjectedPoints,
                        goal: res.data.PointsGoal,
                        goalPercent: res.data.ProjectedPercentGrowthGoalPercent
                    },
                    {
                        ytd: res.data.YtdPercentGrowth,
                        projected: res.data.ProjectedPercentGrowth,
                        goal: res.data.PercentGrowthGoal,
                        goalPercent: res.data.ProjectedPointsGoalPercent
                    }
                ];
            });
    }
}